import { memo, useState } from 'react'
import { ICellRendererParams } from 'ag-grid-community'

export const EmptyCellRenderer = memo((params: ICellRendererParams) => {
  const [hover, setHover] = useState(false)
  // if row index is > 9, dont display animation
  const index = params.node?.rowIndex ?? 0
  if (index >= 1) return null
  const view = params.colDef?.cellEditorParams?.property?.view ?? 'inventory'
  return (
    <span
      className="font-thin text-slate-300"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {hover ? (
        'Double-clic pour ajouter'
      ) : (
        <div>
          <span className="motion-safe: pr-1 text-lg duration-500 motion-safe:animate-ping">
            |
          </span>
          {view !== 'references' ? 'Nouvelle ressource' : 'Nouvelle référence'}
        </div>
      )}
    </span>
  )
})

EmptyCellRenderer.displayName = 'EmptyCellRenderer'
